import {get} from 'lodash';
import moment from 'moment';

// The API reports a survey's state as a sentence: "COMPLETE on 2026-03-03",
// "PARTIAL", or empty for one not started. Read it through here rather than
// matching the string at each call site.
export const isSurveyComplete = survey =>
  get(survey, 'status', '').startsWith('COMPLETE');

export const isSurveyPartial = survey =>
  get(survey, 'status', '').startsWith('PARTIAL');

export const surveyCompletedOn = survey =>
  moment(get(survey, 'status', '').replace('COMPLETE on ', '')).format('Do MMM');
